import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {State} from '../../entity/model/state';

export default class StateAgent {

  getStates = async (): Promise<State[]> => {
    return await API.get(awsApiName, '/locations/states', {});
  }
}